module.exports = __webpack_public_path__ + "static/media/KEEP.28b14315.svg";